import {
    AssaysEvaluationResult
} from '@/modules/diagnosisModule/components/assays-evaluations-grid/assays-evaluations-grid.models'

export interface AssaysEvaluationsModalState {
    assayResultId?: number
    portionId: number
    subportionId: number
    label: string
    assayName: string
    assayGroupName: string
    subportionAccredited: boolean
    subportionVisibleInReport: boolean
    assayResults: AssaysEvaluationResult
}
export const initialAssaysEvaluationsModalState =
    (): AssaysEvaluationsModalState => ({
        portionId: -1,
        subportionId: -1,
        label: '',
        assayName: '',
        assayGroupName: '',
        subportionAccredited: false,
        subportionVisibleInReport: false,
        assayResults: {
            id: -1,
            comment: '',
            customData: null,
            percentage: null,
            possibleAssayResult: {
                active: true,
                code: '',
                name: ''
            }
        }
    })
